<template>
  <div>
    <div>
      <h1>
        <b>NOTAS DA VERSÃO</b>
      </h1>
    </div>
    <hr />
    <div>
      <span>
        <b>1.1.0 [19-02-2021]</b>
      </span>
      <br />
      <br />
      <span
        >&#10148; Foi criado nas permissões do usuário, opções de inativar a
        visualização de Documentos, Pagamento e Recebimentos.</span
      >
      <br />
      <span
        >&#10148; Foi corrigido a busca por nome na tela de Recebimentos do
        Contas à Receber.</span
      >
      <br />
      <br />

      <span>
        <b>1.0.5 [08-07-2020]</b>
      </span>
      <br />
      <br />
      <span
        >&#10148; Foi criado relatórios de vendas, recebimento e vendas por
        vendedor.</span
      >
      <br />
      <span
        >&#10148; Foi criado uma opção no caixa, para informar o tipo de
        documento.</span
      >
      <br />
      <span
        >&#10148; Na tela que lista os recebimentos, foi criada a opção para
        excluir.</span
      >
      <br />
      <br />
      <span>
        <b>1.0.4 [25-06-2020]</b>
      </span>
      <br />
      <br />
      <span>&#10148; Foi criado a opção de Venda Direta.</span>
      <br />
      <span
        >&#10148; Foi feito a correção do erro de acessar o menu com um usuário
        não administrador.</span
      >
      <br />
      <br />
      <span>
        <b>1.0.3 [29-05-2020]</b>
      </span>
      <br />
      <br />
      <span
        >&#10148; Na tela de recebimentos, foi criado a opção para imprimir a
        segunda via.</span
      >
      <br />
      <br />

      <span>
        <b>1.0.2 [22-05-2020]</b>
      </span>
      <br />
      <br />
      <span>
        &#10148; Ao inserir um item no consignado, o cursor irá focar no campo
        código de barras.
        <br />&#10148; O campo quantidade do consignado, ficará com o valor
        padrão 1. <br />&#10148; No cadastro de produtos, foi criada a opção
        para inserir estoque. <br />&#10148; Foi criado um campo nos documentos
        à receber, para setar o dia preferencial de pagamento do cliente.
        <br />&#10148; A fonte dos recibos e comprovante, foram alteradas para
        deixar a impressão menor.
      </span>
      <br />
      <br />
      <span>
        <b>1.0.1 [09-05-2020]</b>
      </span>
      <br />
      <br />
      <span>
        &#10148; Criado botões de acesso rápido na página inicial.
        <br />&#10148; Criado a opção de escolher um vendedor no Consignado.
        <br />&#10148; Criado a página para mostrar os documentos à vencer dos
        clientes. <br />&#10148; Criado opção no cadastro de clientes, para
        definir a impressão do limite no comprovante. <br />&#10148; Nos campos
        QUANTIDADE e DESCONTO no Consignado, é possível inserir um produto
        através da tecla ENTER. <br />&#10148; Ao passar o código de barras no
        Consignado, em seguida será direcionado para o campo quantidade.
        <br />&#10148; No cadastro de usuários, foi criado a opção para ocultar
        o preço de custo dos produtos. <br />&#10148; No cadastro de clientes,
        foi criado um campo para informar o melhor dia de pagamento.
      </span>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>